import { Restoration } from "./restoration";
import { Post } from "./post";
import { Splint } from "./splint";
import { Discolored } from "./discolored";

export const conditions = [Restoration, Post, Splint, Discolored];



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/conditions/restorative/index.ts